export enum DelimiterType {
  newLine = 0,
  commaSemicolon = 1
}